<template>
    <article
        ref="offerCard"
        class="offer-card"
        :id="cardData.id">
        <div class="offer-card__img">
            <a
                class="offer-card__area-link"
                :href="cardData.link">
                <picture v-if="cardData.picture">
                    <img
                        :src="cardData.picture"
                        alt="Фотография объекта"
                        title="Фотография объекта"
                        width="288"
                        height="192" />
                </picture>
                <picture v-else>
                    <source
                        type="image/webp"
                        srcset="/static/v2/src/img/land/empty-img.webp"/>
                    <img
                        src="/static/v2/src/img/land/empty-img.jpg"
                        alt="Фотография объекта"
                        title="Фотография объекта"
                        width="288"
                        height="192" />
                </picture>
            </a>
            <a
                class="offer-card__favorite"
                href="#"
                title="В избранное"
                @click.prevent="favoriteHandler">
                <svg
                    v-show="!isFavorite"
                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.64066 1.66208C10.1665 1.44418 10.7302 1.33203 11.2994 1.33203C11.8687 1.33203 12.4323 1.44418 12.9582 1.66208C13.484 1.87994 13.9617 2.19923 14.3641 2.60173C14.7666 3.0041 15.0861 3.48204 15.3039 4.00782C15.5218 4.53369 15.634 5.09735 15.634 5.66658C15.634 6.23582 15.5218 6.79947 15.3039 7.32535C15.0861 7.85117 14.7667 8.32893 14.3642 8.73132L8.47083 14.6247C8.21048 14.885 7.78837 14.885 7.52802 14.6247L1.63469 8.73132C0.821871 7.9185 0.365234 6.81608 0.365234 5.66658C0.365234 4.51708 0.821871 3.41466 1.63469 2.60184C2.44751 1.78902 3.54993 1.33239 4.69943 1.33239C5.84893 1.33239 6.95135 1.78902 7.76417 2.60184L7.99943 2.83711L8.23458 2.60195C8.63697 2.1994 9.11483 1.87996 9.64066 1.66208ZM11.2994 2.66536C10.9053 2.66536 10.5151 2.74301 10.1511 2.89386C9.78698 3.04471 9.4562 3.26582 9.17761 3.54454L8.47083 4.25132C8.21048 4.51167 7.78837 4.51167 7.52802 4.25132L6.82136 3.54465C6.25859 2.98188 5.49531 2.66572 4.69943 2.66572C3.90355 2.66572 3.14027 2.98188 2.5775 3.54465C2.01473 4.10742 1.69857 4.8707 1.69857 5.66658C1.69857 6.46246 2.01473 7.22574 2.5775 7.78851L7.99943 13.2104L13.4214 7.78851C13.7001 7.50992 13.9213 7.17903 14.0721 6.81496C14.223 6.45089 14.3006 6.06067 14.3006 5.66658C14.3006 5.2725 14.223 4.88228 14.0721 4.51821C13.9213 4.15414 13.7002 3.82336 13.4215 3.54476C13.1429 3.26604 12.8119 3.04471 12.4478 2.89386C12.0837 2.74301 11.6935 2.66536 11.2994 2.66536Z" fill="#252628"/>
                </svg>
                <svg
                    v-show="isFavorite"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.462 0.493732C15.2508 0.166886 16.0963 -0.00134277 16.9501 -0.00134277C17.804 -0.00134277 18.6494 0.166886 19.4383 0.493732C20.2269 0.820519 20.9435 1.29946 21.5471 1.90321C22.1508 2.50676 22.6301 3.22367 22.9569 4.01234C23.2837 4.80115 23.4519 5.64663 23.4519 6.50048C23.4519 7.35433 23.2837 8.19982 22.9569 8.98863C22.6301 9.77737 22.1511 10.494 21.5472 11.0976L12.7072 19.9376C12.3167 20.3281 11.6835 20.3281 11.293 19.9376L2.45301 11.0976C1.23378 9.87836 0.548828 8.22473 0.548828 6.50048C0.548828 4.77623 1.23378 3.1226 2.45301 1.90338C3.67224 0.684148 5.32587 -0.000808001 7.05012 -0.000808001C8.77437 -0.000808001 10.428 0.684148 11.6472 1.90338L12.0001 2.25627L12.3528 1.90354C12.9564 1.29972 13.6732 0.820549 14.462 0.493732Z" fill="#82BF00"/>
                </svg>
            </a>
        </div>
        
        <div class="offer-card__wrap">
            <a
                class="offer-card__area-link"
                :href="cardData.link">
                <div
                    class="offer-card__type"
                    v-html="cardData.props.object_type_ru"></div>
                <div
                    v-if="cardData.props.price"
                    class="offer-card__prices">
                    <div
                        v-if="cardData.props.price"
                        class="offer-card__price">
                        {{ formatNumbers(cardData.props.price) }} ₽
                    </div>
                    <div
                        v-if="cardData.price_history?.length > 1"
                        class="offer-card__old-price">
                        {{ formatNumbers(cardData.price_history[1].price) }} ₽
                    </div>
                    <div
                        v-if="cardData.props.rub_per_sqm"
                        class="offer-card__price-per-meter">
                        {{ formatNumbers(cardData.props.rub_per_sqm) }} ₽/м²
                    </div>
                </div>
                <address
                    class="offer-card__address"
                    v-html="cardData.name"></address>
                <div
                    v-if="cardData.props.auction_date || cardData.props.auction_deadline"
                    class="offer-card__dates">
                    <div
                        v-if="cardData.props.auction_deadline"
                        class="offer-card__date">
                        <div class="offer-card__date-label">
                            Окончание приема заявок:
                        </div>
                        <div
                            class="offer-card__date-time"
                            v-html="cardData.props.auction_deadline"></div>
                    </div>
                    <div
                        v-if="cardData.props.auction_date"
                        class="offer-card__date">
                        <div class="offer-card__date-label">
                            Проведение торгов:
                        </div>
                        <div
                            class="offer-card__date-time"
                            v-html="cardData.props.auction_date"></div>
                    </div>
                </div>
                <ul
                    v-if="cardData.props.rooms || cardData.props.floor || cardData.props.area || cardData.props.section_area"
                    class="offer-card__options">
                    <li
                        v-if="cardData.props.rooms"
                        class="offer-card__option offer-card__option--rooms">
                        {{ `${cardData.props.rooms} ${formatWordOfNum(cardData.props.rooms, ['комната', 'комнаты', 'комнат'])}` }}
                    </li>
                    <li
                        v-if="cardData.props.area"
                        class="offer-card__option offer-card__option--space">
                        {{ cardData.props.area }} м²
                    </li>
                    <li
                        v-if="cardData.props.floor"
                        class="offer-card__option offer-card__option--floor">
                        {{ getFloorsLabel(cardData.props.object_type, cardData.props.floor, cardData.props.floors_count) }}
                    </li>
                    <li
                        v-if="cardData.props.section_area"
                        class="offer-card__option offer-card__option--area">
                        {{ formatNumbers(cardData.props.section_area) }} м²
                    </li>
                </ul>
            </a>
            <div
                v-if="cardData.active === 'Y'"
                class="offer-card__buttons">
                <a
                    class="offer-card__link offer-card__link--black"
                    href="#"
                    title="Задать вопрос"
                    @click.prevent="$emit('offerChosen', cardData)">
                    Задать вопрос
                </a>
                <a
                    v-if="!isMobile"
                    class="offer-card__link"
                    :href="cardData.link"
                    title="Подробнее">
                    Подробнее
                </a>
            </div>
        </div>
        <div
            v-if="cardData.props.lot_status || cardData.props.condition || cardData.active === 'N'"
            class="offer-card__labels">
            <div
                v-if="cardData.props.lot_status === 'announced' && cardData.active === 'Y'"
                class="offer-card__auction">
                Объявленный аукцион
            </div>
            <div
                v-if="cardData.props.lot_status === 'planned' && cardData.active === 'Y'"
                class="offer-card__auction offer-card__auction--planned">
                Планируемый аукцион
            </div>
            <div
                v-if="cardData.active === 'N'"
                class="offer-card__auction offer-card__auction--disabled">
                Лот реализован
            </div>
            <div
                v-if="cardData.props.condition && cardData.active === 'Y'"
                class="offer-card__condition">
                <span>С обременением</span>
                <div class="offer-card__tooltip">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <g clip-path="url(#clip0_1326_30231)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.583984 6.99967C0.583984 10.5435 3.45682 13.4163 7.00065 13.4163C10.5445 13.4163 13.4173 10.5435 13.4173 6.99967C13.4173 3.45585 10.5445 0.583008 7.00065 0.583008C3.45682 0.583008 0.583984 3.45585 0.583984 6.99967ZM12.2506 6.99969C12.2506 9.89918 9.90014 12.2497 7.00064 12.2497C4.10115 12.2497 1.75064 9.89918 1.75064 6.99969C1.75064 4.10019 4.10115 1.74969 7.00064 1.74969C9.90014 1.74969 12.2506 4.10019 12.2506 6.99969Z" fill="#252628"/>
                            <path d="M6.53211 8.17602C6.53211 7.93968 6.58283 7.71945 6.68428 7.51534C6.78573 7.31123 6.90854 7.13666 7.0527 6.99163C7.19687 6.8466 7.34103 6.70963 7.4852 6.58072C7.62936 6.44643 7.75217 6.30141 7.85362 6.14564C7.95507 5.98449 8.00579 5.81529 8.00579 5.63804C8.00579 5.36947 7.91235 5.16536 7.72547 5.0257C7.54393 4.88067 7.30633 4.80816 7.01266 4.80816C6.42532 4.80816 6.04889 5.06867 5.88337 5.5897L5.25064 5.23518C5.38413 4.85919 5.61106 4.5745 5.93142 4.38113C6.25179 4.18239 6.61487 4.08302 7.02067 4.08302C7.49588 4.08302 7.90167 4.2173 8.23806 4.48587C8.57978 4.75444 8.75064 5.12776 8.75064 5.60581C8.75064 5.83141 8.69992 6.04358 8.59847 6.24232C8.49702 6.44106 8.37422 6.61295 8.23005 6.75797C8.08589 6.903 7.94172 7.04534 7.79756 7.185C7.65339 7.31928 7.53058 7.47237 7.42913 7.64425C7.32768 7.81077 7.27696 7.98802 7.27696 8.17602H6.53211ZM6.90053 9.91635C6.75637 9.91635 6.63356 9.86532 6.53211 9.76327C6.43066 9.66121 6.37994 9.53767 6.37994 9.39264C6.37994 9.24761 6.43066 9.12407 6.53211 9.02202C6.63356 8.91996 6.75637 8.86893 6.90053 8.86893C7.05003 8.86893 7.17284 8.91996 7.26895 9.02202C7.3704 9.12407 7.42112 9.24761 7.42112 9.39264C7.42112 9.53767 7.3704 9.66121 7.26895 9.76327C7.17284 9.86532 7.05003 9.91635 6.90053 9.91635Z" fill="#252628"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1326_30231">
                            <rect width="14" height="14" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <div class="offer-card__tooltip-text">
                        Объекты, в которых зарегистрированы и/или проживают третьи лица. Такие объекты реализуются со скидкой.
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    import declineWordOfNum from '../../../modules/decline-word-of-num.js'
    import {getCookie, setCookie, deleteCookie} from '../../../modules/cookie-helper.js'

    export default {
        name: 'OfferCard',
        props: {
            cardData: {
                type: Object,
                default: () => {}
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                isFavorite: false
            }
        },
        methods: {
            favoriteHandler () {
                const card = this.$refs.offerCard
                const coocieFavorite = getCookie('favorite')
                setTimeout(() => {
                    if (card.classList.contains('favorite')) {
                        card.classList.remove('favorite')
                        this.isFavorite = false
                        const newVal = coocieFavorite.split(',').filter(el => el !== this.cardData.id)
                        deleteCookie('favorite')
                        setCookie('favorite', newVal)
                        return
                    }

                    this.$emit('addToFavorite')

                    card.classList.add('favorite')
                    this.isFavorite = true
                    if (!coocieFavorite) {
                        setCookie('favorite', this.cardData.id)
                        return
                    }

                    setCookie('favorite', [coocieFavorite, this.cardData.id])
                }, 0)
            },

            formatNumbers (number) {
                return new Intl.NumberFormat("ru-RU").format(number)
            },
            
            formatWordOfNum (num, textArr) {
                return declineWordOfNum(num, textArr)
            },

            getFloorsLabel(type, floor, floormax) {
                if (type === 'FLAT') {
                    return `${floor}/${floormax} этаж`
                }

                if (!type) {
                    return `${floor} этаж`
                }

                return `${floormax} ${this.formatWordOfNum(floormax, ['этаж', 'этажа', 'этажей'])}`
            }
        },
        mounted() {
            const card = this.$refs.offerCard
            const coocieFavorite = getCookie('favorite')
            if (coocieFavorite === this.cardData.id) {
                card.classList.add('favorite')
                this.isFavorite = true
                return
            }

            const favoritesId = coocieFavorite?.split(',')
            if (favoritesId && favoritesId.includes(this.cardData.id)) {
                card.classList.add('favorite')
                this.isFavorite = true
                return
            }
        }
    }
</script>